import React from 'react';
import styles from './index.module.scss'

const Breadcrumb = (props) => {
  const {pageTitle, parentLink, parentUrl} = props;

  return (
    <div className={styles.wrapper}>
      <ul>
        <li><a href="/">Home</a></li>
        {parentLink && <li><a href={parentUrl}>{parentLink}</a></li>}
        {pageTitle && <li dangerouslySetInnerHTML={{ __html: pageTitle }}></li>}
      </ul>
    </div>
  );
};

export default Breadcrumb;
